import type { FunctionComponent } from 'react';

import { icons, IconText } from '../../../generic/Icon';
import { DocsLink } from '../../../generic/Link';
import Loader from '../../../generic/Loader';
import Tooltip from '../../../generic/Tooltip';

type Props = {
  revisionId: string;
  message: string;
};

const CLIBuildCard: FunctionComponent<Props> = ({ revisionId, message }: Props) => {
  return (
    <div className="project-card card card-primary">
      <div className="row-fluid">
        <div className="col-md-1 project-card-gutter">
          <Loader
            color="#d2b690"
            size={60}
            style={{
              left: '-30px',
            }} />
        </div>
        <div className="col-md-7">
          <b className="inline-header">
            Waiting for build data...
          </b>
          <Tooltip placement="top" tooltip={revisionId} id={revisionId} showTooltip={revisionId.length > 45}>
            <h4 className="oneline">
              {revisionId}
            </h4>
          </Tooltip>
          <h5>{message}</h5>
        </div>
        <div className="col-md-4 project-card-gutter">
          <DocsLink
            to="provided-builds"
            className="btn"
          >
            <IconText
              icon={icons.customize}
              text="Configure Provided Builds"
            />
          </DocsLink>
        </div>
      </div>
    </div>
  );
};

export default CLIBuildCard;
